import {osVersion, osName, browserName, fullBrowserVersion, mobileVendor, mobileModel, engineName, engineVersion}
    from "react-device-detect";
const Info={
    deviceInfo: {
        realOsName: osName,
        osName: "PWA",
        osVersion: osVersion,
        browserName: browserName,
        browserVersion: fullBrowserVersion,
        mobileVendor: mobileVendor,
        mobileModel: mobileModel,
        engineName: engineName,
        engineVersion: engineVersion
    },
    applicationInfo: {
        packageName: "com.asredade.abfa-employee.app.mazandaran",
        downloadSource: "DirectLink",
        appVersionName: "0.0.0",
        appVersionCode: "1"
    }
}

export default Info